import '@fontsource/playfair-display'

const fonts = {
  heading: '"Playfair Display", serif',
  body: 'Helvetica, Arial, sans-serif',
}

export default fonts
